import { getScopedItem, REGISTRATION_TYPE, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService, { setAuthToken } from "./APIService";
import AzureAPIService, { setAzureAuthToken } from "./AzureAPIService";
import DebugService from "./DebugService";

/**
 * @description Registration Api Service
 */
const RegistrationApiService = {
  // Manual Registration
  manual: async (data) => {
    try {
      if (Object.keys(data).length > 0) {
        data['signUpType'] = REGISTRATION_TYPE.MANUAL
      }

      return await APIService.post(APIConstants.ENDPOINT_REGISTRATION, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while registration', err, data)
    }
  },

  // Google Registration
  google: async (data) => {
    try {
      if (Object.keys(data).length > 0) {
        data['signUpType'] = REGISTRATION_TYPE.GOOGLE
      }

      return await APIService.post(APIConstants.ENDPOINT_REGISTRATION, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while registration', err, data)
    }
  },

  // Account linking
  accountLink: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_ACCOUNT_VALIDATE, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while account validation', err, data)
    }
  },
  
  // Verify Email
  verifyEmail: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_VERIFY_EMAIL, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while verifying email', err, data)
    }
  },
  
  // Resend email verification link
  resendEmailLink: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_RESEND_EMAIL_LINK, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while resending email verification link', err, data)
    }
  },

  // User details
  userDetails: async (data) => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const endpoint = `${APIConstants.ENDPOINT_USER_DETAILS}/${data}`
      return await APIService.get(endpoint)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while fetching user details', err, data)
    }
  },

  // Platform List
  getPlatformList: async (userId) => {
    try {
      // if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
      //   setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      // }

      const endpoint = `${APIConstants.ENDPOINT_PLATFORM}?userId=${userId}`
      return await APIService.get(endpoint)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while fetching platform list', err, userId)
    }
  },

  // Init Azure Automate Onboarding
  initAzureAutomateOnboarding: async () => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const endpoint = APIConstants.ENDPOINT_AZURE_INIT_ONBOARDING
      return await AzureAPIService.get(endpoint)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while initiating azure onboarding', err)
    }
  },

  // Get Azure Roles
  getAzureRoles: async () => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const endpoint = APIConstants.ENDPOINT_AZURE_ONBOARDING_ROLES
      return await AzureAPIService.get(endpoint)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while fetching azure roles', err)
    }
  },

  // Get Azure Automate Onboarding Status
  getAzureAutomateOnboardingStatus: async (data) => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const endpoint = APIConstants.ENDPOINT_AZURE_ONBOARDING_STATUS
      return await AzureAPIService.post(endpoint, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while fetching azure onboarding status', err)
    }
  },

  // Get Azure Automate Onboarding Subscription
  getAzureAutomateOnboardingSubscription: async (data) => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const endpoint = APIConstants.ENDPOINT_AZURE_ONBOARDING_SUBSCRIPTION_LIST
      return await AzureAPIService.post(endpoint, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while azure onboarding subscription list', err)
    }
  },

  // Get Azure Automate Onboarding Subscription
  getAzureAutomateOnboardingDetails: async (data) => {
    try {
      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAzureAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const endpoint = APIConstants.ENDPOINT_AZURE_ONBOARDING_DETAILS
      return await AzureAPIService.post(endpoint, data)
    } catch (err) {
      DebugService.error('Registration Api Service: Caught error while azure onboarding setup', err)
    }
  },
};

export default RegistrationApiService;
